import { render, staticRenderFns } from "./cWcity.vue?vue&type=template&id=6230eff6&scoped=true&lang=pug"
import script from "./cWcity.vue?vue&type=script&lang=js"
export * from "./cWcity.vue?vue&type=script&lang=js"
import style0 from "./cWcity.vue?vue&type=style&index=0&id=6230eff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230eff6",
  null
  
)

export default component.exports